export const convertVerticalsToArray = (categoryAgency: string | undefined) => {
  const filteredVerticals = categoryAgency
    ? categoryAgency.split(',').map((v) => v.trim())
    : [];

  return filteredVerticals;
};
